import { carouselData } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          焦点专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          深度聚焦未删减版电影世界的核心专题内容
        </p>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          {carouselData.slice(0, 2).map((item) => (
            <a
              key={item.id}
              href="#carousel"
              className="group bg-background-50 border border-background-200/70 hover:border-accent-400/30 rounded-lg overflow-hidden transition-colors cursor-pointer"
            >
              <div className="relative aspect-[16/9] overflow-hidden bg-background-200">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 via-transparent to-transparent"></div>
              </div>
              <div className="px-5 pb-5">
                <span className="text-xs text-accent-400 whitespace-nowrap">{item.subtitle}</span>
                <h3 className="text-base font-heading text-foreground-800 group-hover:text-accent-400 transition-colors mt-1 mb-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-5">
          {carouselData.slice(2).map((item) => (
            <a
              key={item.id}
              href="#carousel"
              className="group bg-background-50 border border-background-200/70 hover:border-accent-400/30 rounded-lg overflow-hidden transition-colors cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/70 via-transparent to-transparent"></div>
              </div>
              <div className="px-4 pb-4">
                <span className="text-xs text-accent-400 whitespace-nowrap">{item.subtitle}</span>
                <h3 className="text-sm font-heading text-foreground-800 group-hover:text-accent-400 transition-colors mt-1 mb-1.5">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}